const ScriptRunnerConfiguration = ({ selectedConfig, canRunSelectedScript }) => (
  <section className='script-runner-section script-runner-script-header'>
    <div className='script-runner-section-content'>
      <h1>{selectedConfig.name}</h1>
      {selectedConfig.description && <p>{selectedConfig.description}</p>}
      <code>{selectedConfig.scriptPath}</code>
      {!canRunSelectedScript && (
        <div className='script-runner-alert script-runner-alert-warning'>
          You do not have permission to run this script. Its configuration, inputs, history, and logs are available read only.
        </div>
      )}
    </div>
  </section>
);

export default ScriptRunnerConfiguration;
